// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as MediaQuery$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as ModalContext$PorterinFeature from "../../../../../contexts/modal-context/ModalContext.mjs";
import * as AddressContext$PorterinFeature from "../../../../../contexts/address-context/AddressContext.mjs";
import * as ExtendedAddress$PorterinFeature from "../../../domain/entity/ExtendedAddress.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as OrderReviewHelper$PorterinFeature from "../../../../order-review/domain/helpers/OrderReviewHelper.mjs";
import * as OrderReviewContext$PorterinFeature from "../../../../../contexts/order-review-context/OrderReviewContext.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../domain/store/FareEstimateStoreV1.mjs";
import * as EditBookingDetailsCmp$PorterinFeature from "./EditBookingDetailsCmp.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../../../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";
import * as OrderReviewAddressState$PorterinFeature from "../../../domain/entity/edit-address/OrderReviewAddressState.mjs";
import * as LocationAccuracyModalCmp$PorterinFeature from "../location-accuracy/view/LocationAccuracyModalCmp.mjs";
import * as FareEstimateResultStateV1$PorterinFeature from "./FareEstimateResultStateV1.mjs";
import * as OrderReviewAddressInterface$PorterinFeature from "../../../domain/entity/edit-address/OrderReviewAddressInterface.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../../../shared/core/helpers/FareEstimateResultFormHelper.mjs";
import * as FareEstimateResultFormInterfaceV1$PorterinFeature from "../../../../../shared/lead-flow/view/component/result-form/FareEstimateResultFormInterfaceV1.mjs";
import * as EditBookingDetailsWrapperModuleScss from "../../styles/EditBookingDetailsWrapper.module.scss";

var styles = EditBookingDetailsWrapperModuleScss;

function EditBookingDetailsMobileWrapperCmp(Props) {
  var close_modal = Props.close_modal;
  var waypoint = Props.waypoint;
  var is_address_modal_openOpt = Props.is_address_modal_open;
  var is_address_modal_open = is_address_modal_openOpt !== undefined ? is_address_modal_openOpt : false;
  var match = React.useState(function () {
        return is_address_modal_open;
      });
  var setShowModal = match[1];
  var match$1 = React.useState(function () {
        
      });
  var setPreviousResponse = match$1[1];
  var match$2 = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  var query_params = match$2.query_params;
  var match$3 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var set_is_serviceable_dropoff = match$3.set_is_serviceable_dropoff;
  var set_is_serviceable_pickup = match$3.set_is_serviceable_pickup;
  var recaptchaContext = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var recaptchaExecute = NextRecaptchaV3.useReCaptcha();
  var match$4 = ModalContext$PorterinFeature.useModalContext(undefined);
  var toggleModal = match$4.toggleModal;
  var match$5 = AddressContext$PorterinFeature.useAddressContext(undefined);
  var receiver = match$5.receiver;
  var sender = match$5.sender;
  var orderConttext = OrderReviewContext$PorterinFeature.useOrderReviewContext(undefined);
  var addressContext = AddressContext$PorterinFeature.useAddressContext(undefined);
  var isMobile = MediaQuery$PorterinUtils.isMobile(undefined);
  var router = Router.useRouter();
  var match$6 = OrderReviewHelper$PorterinFeature.getPrimarySecondaryAddress(sender.pickup_address.landmark);
  var match$7 = OrderReviewHelper$PorterinFeature.getPrimarySecondaryAddress(receiver.drop_address.landmark);
  var initialInput = FareEstimateResultStateV1$PorterinFeature.initialFormState(query_params);
  var orderReviewFormInitialState = OrderReviewAddressState$PorterinFeature.initialFormState(orderConttext.query_params);
  var fareEstimateForm = FareEstimateResultFormInterfaceV1$PorterinFeature.Form.useForm(initialInput, (function (output, callbacks) {
          Curry._1(set_is_serviceable_dropoff, true);
          Curry._1(set_is_serviceable_pickup, true);
          Curry._1(close_modal, undefined);
          FareEstimateResultStateV1$PorterinFeature.onFormSubmit(set_is_serviceable_dropoff, set_is_serviceable_pickup, output, callbacks, query_params, recaptchaExecute, setPreviousResponse, citySelectedContext.category, isMobile, recaptchaContext, true);
        }));
  var orderReviewForm = OrderReviewAddressInterface$PorterinFeature.Form.useForm(orderReviewFormInitialState, (function (output, callbacks) {
          Curry._1(set_is_serviceable_dropoff, true);
          Curry._1(set_is_serviceable_pickup, true);
          Curry._1(close_modal, undefined);
          OrderReviewAddressState$PorterinFeature.onFormSubmit(orderConttext, addressContext, waypoint, output, toggleModal);
        }));
  var pickupAddressOnChange = function (addressValue, postalAddress) {
    var match = orderConttext.query_params;
    var to_long = match.to_long;
    var to_lat = match.to_lat;
    var to_landmark = match.to_landmark;
    Curry._2(orderReviewForm.updatePickup_address, (function (input, value) {
            return {
                    pickup_address: {
                      landmark: value.landmark,
                      location: value.location,
                      extended_address: FareEstimateResultFormHelper$PorterinFeature.getExtendedAddressFromPostal(postalAddress)
                    },
                    drop_address: {
                      landmark: FareEstimateResultFormHelper$PorterinFeature.getLandmarkLocation(to_landmark),
                      location: {
                        lat: FareEstimateResultFormHelper$PorterinFeature.getLocationCoordinates(to_lat),
                        lng: FareEstimateResultFormHelper$PorterinFeature.getLocationCoordinates(to_long)
                      },
                      extended_address: ExtendedAddress$PorterinFeature.initial_extended_address(undefined)
                    }
                  };
          }), {
          landmark: addressValue.landmark,
          location: addressValue.location,
          extended_address: FareEstimateResultFormHelper$PorterinFeature.getExtendedAddressFromPostal(postalAddress)
        });
    Curry._1(orderReviewForm.submit, undefined);
  };
  var dropAddressOnChange = function (addressValue, postalAddress) {
    var match = orderConttext.query_params;
    var from_long = match.from_long;
    var from_lat = match.from_lat;
    var from_landmark = match.from_landmark;
    Curry._2(orderReviewForm.updateDrop_address, (function (input, value) {
            return {
                    pickup_address: {
                      landmark: FareEstimateResultFormHelper$PorterinFeature.getLandmarkLocation(from_landmark),
                      location: {
                        lat: FareEstimateResultFormHelper$PorterinFeature.getLocationCoordinates(from_lat),
                        lng: FareEstimateResultFormHelper$PorterinFeature.getLocationCoordinates(from_long)
                      },
                      extended_address: ExtendedAddress$PorterinFeature.initial_extended_address(undefined)
                    },
                    drop_address: {
                      landmark: value.landmark,
                      location: value.location,
                      extended_address: FareEstimateResultFormHelper$PorterinFeature.getExtendedAddressFromPostal(postalAddress)
                    }
                  };
          }), {
          landmark: addressValue.landmark,
          location: addressValue.location,
          extended_address: FareEstimateResultFormHelper$PorterinFeature.getExtendedAddressFromPostal(postalAddress)
        });
    Curry._1(orderReviewForm.submit, undefined);
  };
  console.trace();
  return React.createElement("div", {
              className: styles["edit-booking-details-wrapper"]
            }, React.createElement("div", {
                  className: styles["booking-details"]
                }, React.createElement("div", {
                      className: styles["current-address-container"]
                    }, React.createElement("div", {
                          className: styles["waypoint-indicator"]
                        }, waypoint ? React.createElement("div", {
                                className: styles["drop-indicator-wrapper"]
                              }, React.createElement("div", {
                                    className: styles.indicator
                                  })) : React.createElement("div", {
                                className: styles["pickup-indicator-wrapper"]
                              }, React.createElement("div", {
                                    className: styles.indicator
                                  }))), React.createElement("div", {
                          className: styles["current-address-wrapper"]
                        }, React.createElement("p", {
                              className: styles["current-address-primary"]
                            }, waypoint ? match$7[0] : match$6[0]), React.createElement("p", {
                              className: styles["current-address-secondary"]
                            }, waypoint ? match$7[1] : match$6[1]))), React.createElement("button", {
                      className: styles["edit-address-button"],
                      onClick: (function (param) {
                          Curry._1(setShowModal, (function (param) {
                                  return true;
                                }));
                        })
                    }, FareEstimateStoreV1$PorterinFeature.edit_address_button)), React.createElement(EditBookingDetailsCmp$PorterinFeature.make, {
                  waypoint: waypoint,
                  close_modal: close_modal,
                  sender: sender,
                  receiver: receiver,
                  set_sender: match$5.set_sender,
                  set_receiver: match$5.set_receiver
                }), React.createElement(LocationAccuracyModalCmp$PorterinFeature.make, {
                  modal_state: match[0],
                  waypoint: waypoint,
                  close_modal: (function (param) {
                      Curry._1(setShowModal, (function (param) {
                              return false;
                            }));
                    }),
                  on_location_select: (function (address, geoPostalAddress) {
                      var match = router.pathname;
                      if (match === "/order-review") {
                        if (waypoint) {
                          dropAddressOnChange(address, geoPostalAddress);
                        } else {
                          pickupAddressOnChange(address, geoPostalAddress);
                        }
                        return Curry._1(orderReviewForm.submit, undefined);
                      } else {
                        if (waypoint) {
                          Curry._2(fareEstimateForm.updateDrop_address, (function (input, value) {
                                  return {
                                          pickup_address: input.pickup_address,
                                          drop_address: value,
                                          category: input.category
                                        };
                                }), address);
                        } else {
                          Curry._2(fareEstimateForm.updatePickup_address, (function (input, value) {
                                  return {
                                          pickup_address: value,
                                          drop_address: input.drop_address,
                                          category: input.category
                                        };
                                }), address);
                        }
                        return Curry._1(fareEstimateForm.submit, undefined);
                      }
                    })
                }));
}

var make = EditBookingDetailsMobileWrapperCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
